export const getDataRegistrazioneSg = (values) => {
  const params = {
    utente: {
      tipologia_utente_chiave: values.utente.tipologia,
      nome: values.utente.nome,
      cognome: values.utente.cognome,
      email: values.utente.username, // email = username
      telefono: values.utente.telefono,
      username: values.utente.username,
      password: values.utente.password,
      privacy: true,
      privacy_commerciale: values.autorizzazioni.privacy_commerciale,
    },
    anagrafica: {
      // valori da indirizzo fatturazione con fallback su indirizzo spedizione
      ragione_sociale:
        values.dati_indirizzo.ragione_sociale || values.dati_indirizzo_spedizione.ragione_sociale,
      partita_iva:
        values.dati_indirizzo.partita_iva || values.dati_indirizzo_spedizione.partita_iva,
      cod_fiscale:
        values.dati_indirizzo.cod_fiscale || values.dati_indirizzo_spedizione.cod_fiscale,
      email: values.dati_indirizzo.email || values.dati_indirizzo_spedizione.email,
      telefono: values.dati_indirizzo.telefono || values.dati_indirizzo_spedizione.telefono,
      sottocanale_commerciale_id: null,
    },
    indirizzo:
      Object.keys(values.dati_indirizzo).length > 0
        ? {
            nome: values.dati_indirizzo.nome,
            cognome: values.dati_indirizzo.cognome,
            ragione_sociale: values.dati_indirizzo.ragione_sociale,
            nazione_id: values.dati_indirizzo.nazione_id,
            indirizzo: values.dati_indirizzo.indirizzo,
            email: values.dati_indirizzo.email,
            cap: values.dati_indirizzo.cap,
            citta: values.dati_indirizzo.citta,
            provincia: values.dati_indirizzo?.provincia,
            telefono: values.dati_indirizzo.telefono,
            cod_fiscale: values.dati_indirizzo.cod_fiscale,
            partita_iva: values.dati_indirizzo.partita_iva,
            sdi: values.dati_indirizzo.sdi,
            pec: values.dati_indirizzo.pec,
          }
        : null,
    indirizzo_spedizione:
      Object.keys(values.dati_indirizzo_spedizione).length > 0
        ? {
            nome: values.dati_indirizzo_spedizione.nome,
            cognome: values.dati_indirizzo_spedizione.cognome,
            ragione_sociale: values.dati_indirizzo_spedizione.ragione_sociale,
            nazione_id: values.dati_indirizzo_spedizione.nazione_id,
            indirizzo: values.dati_indirizzo_spedizione.indirizzo,
            email: values.dati_indirizzo_spedizione.email,
            cap: values.dati_indirizzo_spedizione.cap,
            citta: values.dati_indirizzo_spedizione.citta,
            provincia: values.dati_indirizzo_spedizione?.provincia,
            telefono: values.dati_indirizzo_spedizione.telefono,
            cod_fiscale: values.dati_indirizzo_spedizione.cod_fiscale,
            partita_iva: values.dati_indirizzo_spedizione.partita_iva,
            sdi: values.dati_indirizzo_spedizione.sdi,
            pec: values.dati_indirizzo_spedizione.pec,
          }
        : null,
  }

  return params
}

export const getDataCheckRegistrazioneSg = (values) => {
  const params = {
    username: values.utente.username,
    email: values.utente.email,
    partita_iva: values.dati_indirizzo.partita_iva || values.dati_indirizzo_spedizione.partita_iva,
    nazione_id: values.dati_indirizzo.nazione_id || values.dati_indirizzo_spedizione.nazione_id,
    admin_template: false,
  }

  return params
}

export const getDataOrdineSg = (
  values,
  carrelloId,
  indirizzoRegistrazione,
  indirizzoFatturazioneRegistrazione
) => {
  const params = {
    sistema_pagamento: values.id_modalita_pagamento,
    modalita_spedizione: values.tipo_spedizione_id,
    ...((values.indirizzo?.id || indirizzoRegistrazione) && {
      indirizzo: values.indirizzo?.id || indirizzoRegistrazione,
    }),
    ...((values.indirizzo_fatturazione?.id || indirizzoFatturazioneRegistrazione) && {
      indirizzo_fatturazione:
        values.indirizzo_fatturazione?.id || indirizzoFatturazioneRegistrazione,
    }),
    fattura_richiesta: values.fattura_richiesta,
    email: values.email_spedizione || values.utente?.email,
    documento_trasporto: values.documento_trasporto,
    email_bozza_digitale: values.email_bozza_digitale,
    carrello_main_id: values.carrello_main_id,
    note: values.note_ordine ? values.note_ordine : null,
    porto: values.porto_id,
    vettore: values.vettore_id,
    carrello: carrelloId,
    altro_vettore: values?.altro_vettore ? values?.altro_vettore : undefined,
    codice_sconto: values.codice_sconto,
  }

  return params
}
